import { App } from './App';
import { apiUrl, BASE_OPTIONS } from './config/constants';

document.addEventListener('DOMContentLoaded', async () => {
  let options = BASE_OPTIONS;
  try {
    const data = await fetch(`${apiUrl}/onepager.json`);
    options = await data.json();
  } catch (e) {
    console.error('Error occurred while loading onepager config: ', e);
  }

  new App().init(options);
});
